import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

import {
  Card,
  Table,
  Button,
  Badge,
  Dropdown,
  Form,
  Pagination,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaRedo, FaSearch } from "react-icons/fa";
import {
  callToast,
  showErrorMessages,
  getDefaultColumns,
} from "../../../../src/services/utilityFunctions.js";
// import AddHostelFacilityComponent from "./add-hostel-facilities-form.js";
import { useNavigate, useParams } from "react-router-dom";
import {
  InitialsAvatar,
  DropdownIndicator,
} from "../../dashboard/widget/tableWidget.js";
import { updateGroupUser } from "../../../services/Users-services";
import { useGlobalState } from "../../../services/hostelConst.js";
import { getLocalStorageData } from "../../../services/axiosComponent.js";
import MasterActions from "../../dashboard/widget/MasterActions.js";
// import UpdateHostelFacilityComponent from "./update-hostel-facilities-compo.js";
const MasterTable2 = ({
  getList,
  deleteFun,
  groupLevelList,
  actions,
  details,
  updateFun,
  type,
  subTitle,
  title,
  groupId,
  departmentId,
  AddForm,
  isAdmin,
  methods,
  adminId,
  roleId,
  hostelId,
  roomId,
  tab1,
  tab2,
  userId,
}) => {
  const ownerId = details?.["_GROUP OWNER"] ?? null;
  const [columns, setColumns] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const { modalState, closeModal, openModal } = useGlobalState();
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 8;
  const navigate = useNavigate();
  const handleAddForm = () => {
    console.log("calllinnnnng meeeee in master table 2: ", details);
    openModal({
      ...modalState,
      isEditing: false,
      isOpen: true,
      body: <AddForm data={details} refresh={fetchList} navigate={navigate} />,
    });
  };
  const getColumnsList = (defaultColumns) => {
    return Object.keys(defaultColumns).filter((key) => {
      if (key.startsWith("_")) return false;

      if (!defaultColumns[key]) return false;
      return true;
    });
  };

  const addUserConfigure = () => {
    if (tab2 == "Groups") {
      return isAdmin != null && isAdmin == true;
    }
    return true;
  };
  useEffect(() => {
    fetchList();
  }, [currentPage]);

  const fetchList = async ({ isLoading = true } = {}) => {
    if (isLoading) setLoading(true);
    const response = await getList({
      type: type,
      hostelId: hostelId,
      roomId,
      userId,
      roleId,
      groupId,
      departmentId,
    });

    if (response.status === "success") {
      console.log(response.data, "response");
      const defaultColumns = getDefaultColumns(tab1, tab2);
      const col = getColumnsList(defaultColumns);
      console.log(col, "columns");
      setColumns(col);

      setData(response.data);
      var filteredData = response.data.filter((item) => {
        return col.some((column) => {
          const value = item[column];
          if (!value || typeof value !== "string") return false;
          return value.toLowerCase().includes(searchQuery.toLowerCase());
        });
      });

      setTotalPages(Math.ceil(response.data.length / itemsPerPage));
      setStartIndex((currentPage - 1) * itemsPerPage);
      setPaginatedData(
        filteredData.slice(startIndex, startIndex + itemsPerPage)
      );
    } else if (response.status === "fail") {
      showErrorMessages({ data: response, navigate });
    }
    if (isLoading) setLoading(false);
  };

  const [filteredData, setFilteredData] = useState([]);
  // const filteredData = data.filter((item) => {
  //   return columns.some((column) => {
  //     const value = item[column];
  //     if (!value || typeof value !== "string") return false;
  //     return value.toLowerCase().includes(searchQuery.toLowerCase());
  //   });
  // });

  const [totalPages, setTotalPages] = useState(null);
  const [startIndex, setStartIndex] = useState(0);
  const [paginatedData, setPaginatedData] = useState([]);
  // const startIndex = (currentPage - 1) * itemsPerPage;

  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const paginatedData = filteredData.slice(
  //   startIndex,
  //   startIndex + itemsPerPage
  // );
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);

    var filteredData = data.filter((item) => {
      return columns.some((column) => {
        const value = item[column];
        if (!value || typeof value !== "string") return false;
        return value.toLowerCase().includes(event.target.value.toLowerCase());
      });
    });

    setPaginatedData(filteredData.slice(startIndex, startIndex + itemsPerPage));

    setCurrentPage(1);
  };

  return (
    <Card className="p-3 " style={{ width: "100%" }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>{title}</h4>
        <div className="d-flex align-items-end">
          {addUserConfigure() ? (
            <Button
              variant="primary"
              className="d-flex align-items-center me-3"
              onClick={() => {
                handleAddForm(<AddForm data={details} refresh={fetchList} />);
              }}
            >
              <FaPlus className="me-2" /> Add {subTitle}
            </Button>
          ) : null}
          <div className="position-relative me-2" style={{ maxWidth: "300px" }}>
            <Form.Control
              type="text"
              placeholder={`Search ${subTitle}...`}
              value={searchQuery}
              onChange={handleSearch}
              style={{ borderRadius: "20px", paddingLeft: "35px" }}
            />
            <FaSearch
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          <Button variant="light" className="me-2">
            <FaRedo onClick={fetchList} />
          </Button>
        </div>
      </div>

      <Card.Body
        className="table-responsive   rounded"
        style={{ padding: "1rem", flexGrow: 1, overflow: "auto" }}
      >
        <Table bordered hover style={{ overflow: "auto" }}>
          <thead>
            {columns == null ? null : (
              <tr>
                {columns.map((column) => {
                  return <th>{column}</th>;
                })}
                <th
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "400px",
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  ACTION
                </th>
              </tr>
            )}
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center">
                  Loading...
                </td>
              </tr>
            ) : paginatedData.length ? (
              paginatedData.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: "white",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    transition: "transform 0.2s ease",
                    ":hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  {columns.map((column, index) => {
                    return (
                      <CellContent
                        filed={column}
                        groupLevelList={groupLevelList}
                        data={item}
                        isAdmin={details?.["_IS ADMIN"] == "Y" ? true : false}
                        groupId={groupId}
                        ownerId={ownerId}
                        userId={userId}
                      />
                    );
                  })}
                  <td className="center">
                    <MasterActions
                      disableDelete={
                        item?.["_USER ID"]
                          ? ownerId === item["_USER ID"]
                          : false
                      }
                      key={index}
                      refresh={fetchList}
                      item={item}
                      actions={actions}
                      methods={methods}
                      deleteRow={deleteFun}
                      deleteMessage={
                        item?.["_USER ID"]
                          ? item["_USER ID"] == userId
                            ? "Are you sure you want to leave this group?"
                            : null
                          : null
                      }
                      deleteLabel="Remove"
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card.Body>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <span>
          Showing {startIndex + 1}-
          {Math.min(startIndex + itemsPerPage, paginatedData.length)} of{" "}
          {data.length} entries
        </span>
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </Card>
  );
};
const tableStyles = {
  cell: {
    maxWidth: "200px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  specialColumns: {
    NAME: { maxWidth: "150px" },
    DESCRIPTION: { maxWidth: "200px" },
    EMAIL: { maxWidth: "180px" },
  },
};
const CellContent = ({
  filed,
  data,
  isAdmin,
  groupId,
  ownerId,
  userId,
  groupLevelList,
}) => {
  const cellStyle = {
    ...tableStyles.cell,
    ...(tableStyles.specialColumns[filed] || {}),
  };
  const isEditable = () => {
    if (isAdmin) {
      if (data["_USER ID"] == ownerId || data["_USER ID"] == userId) {
        return false;
      }
      return true;
    }
    return false;
  };

  switch (filed) {
    case "NAME":
      return (
        <td className="text-center align-middle">
          <InitialsAvatar displayName={data[filed]} />
        </td>
      );
    case "GROUP LEVEL":
      return (
        <td className="text-center align-middle">
          <EditableTableCell
            groupLevelList={groupLevelList}
            data={data}
            isEditable={isEditable()}
            groupId={groupId}
          />
        </td>
      );
    case "STATUS":
      return (
        <td>
          <Badge
            bg=""
            style={{
              width: "70px",
              padding: "4px 7px",
              fontSize: "0.75rem",
              fontWeight: "400", // Reduced weight
              backgroundColor: data[filed] === "Y" ? "#e8f5e9" : "#ffebee", // Soft pastel backgrounds
              color: data[filed] === "Y" ? "#2e7d32" : "#c62828", // Muted text colors
              // border: `1px solid ${
              //   item[itemKey] === "Y" ? "#a5d6a7" : "#ef9a9a"
              // }`, // Subtle border
              borderRadius: "4px",
              textTransform: "uppercase",
              letterSpacing: "0.4px",
            }}
          >
            {data[filed] === "Y" ? "Active" : "Inactive"}
          </Badge>
        </td>
      );
    default:
      return (
        <td
          className="text-center align-middle"
          style={cellStyle}
          title={data[filed]}
        >
          {data[filed] == null || data[filed] === "" ? "-" : data[filed]}
        </td>
      );
  }
};

const EditableTableCell = ({
  groupLevelList,
  data,

  isEditable,
  groupId,
}) => {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState({
    value: data["_GROUP LEVEL"],
    label: data["GROUP LEVEL"],
  });

  const selectRef = useRef(null);
  const [options, setOptions] = useState(groupLevelList);
  const [updating, setUpdating] = useState(false);
  useEffect(() => {
    if (isEditing && selectRef.current) {
      selectRef.current.focus();
    }
  }, [isEditing]);

  const handleDoubleClick = () => {
    if (isEditable) {
      setIsEditing(true);
    }
  };
  const handleBlur = () => setIsEditing(false);

  const updateUserLevel = async (selected, previousValue) => {
    setUpdating(true);
    var res = await updateGroupUser({
      // adminId: adminId,
      groupId: groupId,
      levelId: selected.value,
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
      regionId: data["_REGION"],
      siteId: data["_SITE"],
      userId: data["_USER ID"],
    });
    console.log(res, "res");
    if (res.status == "success") {
      setValue({
        value: selected.value,
        label: selected.label,
      });
      callToast("success", "Success", "User level updated successfully");
    } else {
      setValue(previousValue);
      showErrorMessages({ data: res, navigate });
    }
    setUpdating(false);
    handleBlur();
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "38px",
      border: "1px solid #ced4da",
      borderRadius: "4px",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
        : "none",
      "&:hover": {
        borderColor: "#adb5bd",
      },
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "8px",
      color: "#495057",
      "&:hover": {
        color: "#495057",
      },
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: "#ced4da",
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: "4px",
      borderRadius: "4px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: state.isSelected ? "#e9ecef" : "white",
      color: "#212529",
      "&:hover": {
        backgroundColor: "#f8f9fa",
      },
    }),
  };

  return (
    <td
      onDoubleClick={handleDoubleClick}
      style={{
        padding: "8px",
        minWidth: "240px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative",
      }}
    >
      {isEditing ? (
        <Select
          ref={selectRef}
          autoFocus
          menuIsOpen
          // disabled={!updating}
          options={options}
          value={value}
          onChange={(selected) => {
            if (!updating) updateUserLevel(selected, value);
          }}
          onBlur={handleBlur}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={
            updating
              ? {
                  DropdownIndicator,
                }
              : null
          }
        />
      ) : (
        <div
          style={{
            padding: "6px 12px",
            borderRadius: "4px",
            border: "1px solid transparent",
            "&:hover": {
              borderColor: "#ced4da",
            },
          }}
        >
          {value.label}
        </div>
      )}
    </td>
  );
};

export default MasterTable2;
